var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvascontainer",staticClass:"canvas-container-animation-spine-winterbonusjagd-kingspass",attrs:{"id":"canvas-container-animation-spine-winterbonusjagd-kingspass"}})
}
var staticRenderFns = []

export { render, staticRenderFns }